<template>
   <div class="base-div" style="padding-bottom: 30px;">
		<ul class="question-wrap">
			<li class="clearfix" v-for="(item,index) in dataList" :key="item.id">
				<img src="../../../assets/question_icon.png"/>
				<div class="question-txt">
					<h6>{{index+1}}、{{item.title}}</h6>
					<p>{{item.content}}</p>
				</div>
			</li>
			<ContentNo content="暂时没有常见问题" v-if="dataList.length<=0"/>
		</ul>
		<div class="page-size">
			<el-pagination
			background
			@current-change="handleCurrentChange"
			:page-size= this.pageSize
			layout="prev, pager, next"
			hide-on-single-page
			:total= this.total>
			</el-pagination>
		</div>
	</div>
</template>
<script>
import qs from 'qs'
import { post,ajaxParam } from '../../../units/request.js'
import ContentNo from '../../../components/contentno'
export default {
    name: '',
	components: {
		ContentNo
	},
	data(){
		return{
			dataList: [],
			activityId: '',
			pageNum: 1,
			pageSize: 10,
			total: 0
		}
	},
	methods: {
		async getDataList(){
			let param = {
				activityId: this.activityId,
				pageNum: this.pageNum,
				pageSize: this.pageSize
			}
			ajaxParam(param)
			const res = await post('v1/activity/getActivityProblem', qs.stringify(param))
			this.dataList = res.data.list
			this.total = res.data.total
			//console.log(this.dataList)
		},
		handleCurrentChange(e){
			this.dataList = []
			this.pageNum = e
			this.getDataList()
		},
		//获取当前活动信息
		async getActiveInfo(){
			let url = 'v1/activity/getIndexActivity'
			let param = {}
			const res = await post(url, param)
			if(res.data.code==200) {
				let entity = res.data.entity
				this.activityId = entity.id
				localStorage.setItem('activityId', entity.id)
				localStorage.setItem('activityType', entity.activityType)
				localStorage.setItem('activeInfo', JSON.stringify(entity))
			} else {
				this.$message.error(res.data.msg)
			}
		}
	},
	created(){
		let activityId = localStorage.getItem('activityId')
		if(activityId!=null) {
			this.activityId = activityId
			this.getDataList()
		} else {
			this.getActiveInfo()
		}
	}
}
</script>
<style scoped>
.question-wrap li{margin-bottom: 60px}
.question-wrap li img{float:left; width: 58px; height:58px; margin-right: 20px}
.question-txt{float: left; width:92%; font-weight: 400;}
.question-txt h6{margin-bottom:20px; font-size: 22px; line-height: 28px;}
.question-txt p{font-size: 14px; color:#777; line-height: 20px;}
</style>
